import { TweenLite } from 'gsap';
import 'ScrollToPlugin';
import ScrollMagic from 'scrollmagic';
import 'animation.gsap';

document.addEventListener('DOMContentLoaded', () => {
  const scrollToTop = document.querySelector('[data-type="scroll-to-top"]');
  const content = document.querySelector('[data-type="content"]');
  if (!content) return;

  TweenLite.set(scrollToTop, { y: 65 });
  scrollToTop.addEventListener('click', () => {
    TweenLite.to(window, 2, { scrollTo: { y: 0, ease: Expo.easeOut, autoKill: false } });
  });

  const controller = new ScrollMagic.Controller();

  new ScrollMagic.Scene({
    triggerElement: content,
    triggerHook: 'onLeave',
  }).setTween(scrollToTop, 1, {
    y: 0,
  }).addTo(controller);
});



// WEBPACK FOOTER //
// ./scripts/elements/scroll-to-top.js